export default __webpack_public_path__ + "static/media/pricing-blue.807e856c.svg";